document.addEventListener('DOMContentLoaded', function () {
  // Hide all quantity wrappers initially
  document.querySelectorAll('.quantity-wrapper').forEach(wrapper => {
    wrapper.classList.add('hidden');
  });

  // --- New: Fetch cart state on page load ---
  fetch('/cart.js', {
    method: 'GET',
    headers: { 'Accept': 'application/json' }
  })
  .then(response => response.json())
  .then(cart => {
    document.querySelectorAll('.add-to-cart-form').forEach(form => {
      const variantId = form.querySelector('input[name="id"]').value;
      const button = form.querySelector('.add-to-cart-button');
      const qtyWrapper = form.querySelector('.quantity-wrapper');
      const qtyInput = form.querySelector('.qty-input');

      // Check if this product's variant is in the cart
      const cartItem = cart.items.find(item => item.variant_id == variantId);

      if (cartItem) {
        // If it's in the cart, update the UI
        qtyInput.value = cartItem.quantity;
        button.classList.add('hidden');
        qtyWrapper.classList.remove('hidden');
      } else {
        // Ensure initial state is correct for products not in cart
        qtyInput.value = 1; // Reset to 1
        button.classList.remove('hidden'); // Show "Add to Cart" button
        qtyWrapper.classList.add('hidden'); // Hide quantity selector
      }
    });
  })
  .catch(error => {
    console.error('Error fetching cart:', error);
    // Gracefully handle error, e.g., keep default UI
  });


  document.body.addEventListener('click', function (e) {
    // Handle plus button
    if (e.target.closest('.qty-btn.plus')) {
      e.preventDefault();
      const form = e.target.closest('.add-to-cart-form');
      const input = form.querySelector('.qty-input');
      let currentQuantity = parseInt(input.value || 1);
      input.value = currentQuantity + 1; // Increment quantity

      addItemToCart(form, 1); // Add 1 more item
      return;
    }

    // Handle minus button
    if (e.target.closest('.qty-btn.minus')) {
      e.preventDefault();
      const form = e.target.closest('.add-to-cart-form');
      const input = form.querySelector('.qty-input');
      let currentQuantity = parseInt(input.value || 1);

      if (currentQuantity > 1) {
        input.value = currentQuantity - 1;
        const variantId = form.querySelector('input[name="id"]').value;
        updateCartItemQuantity(variantId, currentQuantity - 1, form); // Update to new quantity
      } else {
        // If quantity is 1 and minus is clicked, remove the item and revert to "Add to Cart" button
        const variantId = form.querySelector('input[name="id"]').value;
        updateCartItemQuantity(variantId, 0, form);
      }
      return;
    }

    // Handle add to cart button (initial click)
    if (e.target.closest('.add-to-cart-button')) {
      e.preventDefault();

      const button = e.target.closest('.add-to-cart-button');
      const form = button.closest('.add-to-cart-form');
      const qtyWrapper = form.querySelector('.quantity-wrapper');
      const qtyInput = form.querySelector('.qty-input');

      // Add item to cart (initial quantity is 1)
      addItemToCart(form, parseInt(qtyInput.value || 1))
        .then(() => {
          // On successful add, hide the button and show the quantity wrapper
          button.classList.add('hidden');
          qtyWrapper.classList.remove('hidden');
        })
        .catch(err => {
          console.error('❌ Error:', err);
          alert('❌ Error adding to cart');
        });
      return;
    }
  });

  // --- Helper Functions for Cart Interactions ---
  /**
   * Adds an item to the cart via AJAX.
   * @param {HTMLFormElement} form The form element containing the variant ID.
   * @param {number} quantity The quantity to add.
   * @returns {Promise<Object>} A promise that resolves with the cart data.
   */
  function addItemToCart(form, quantity) {
    const formData = new FormData();
    formData.append('id', form.querySelector('input[name="id"]').value);
    formData.append('quantity', quantity);

    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(res => {
      if (!res.ok) {
        return res.json().then(errorData => {
          const errorMessage = errorData.description || 'Failed to add to cart';
          throw new Error(errorMessage);
        });
      }
      return res.json();
    })
    .then(data => {
      console.log('✅ Added to cart:', data);
      // You might want to update a global cart count displayed elsewhere
      // e.g., if you have a cart icon with a number
      return data;
    });
  }

  /**
   * Updates the quantity of a specific item in the cart.
   * This is more robust for changing existing item quantities, including removing (setting quantity to 0).
   * @param {string} variantId The ID of the product variant.
   * @param {number} newQuantity The new quantity for the item.
   * @param {HTMLFormElement} form The associated product form (for UI updates).
   * @returns {Promise<Object>} A promise that resolves with the updated cart data.
   */
  function updateCartItemQuantity(variantId, newQuantity, form) {
    const data = {
      updates: {
        [variantId]: newQuantity
      }
    };

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(res => {
      if (!res.ok) {
        return res.json().then(errorData => {
          const errorMessage = errorData.description || 'Failed to update cart';
          throw new Error(errorMessage);
        });
      }
      return res.json();
    })
    .then(cartData => {
      console.log('✅ Cart updated:', cartData);

      const button = form.querySelector('.add-to-cart-button');
      const qtyWrapper = form.querySelector('.quantity-wrapper');
      const qtyInput = form.querySelector('.qty-input');

      // Check if the item still exists in the cart (its quantity > 0)
      const updatedItem = cartData.items.find(item => item.variant_id == variantId);

      if (newQuantity === 0 || !updatedItem || updatedItem.quantity === 0) {
        // Item was removed or quantity went to 0
        button.classList.remove('hidden'); // Show "Add to Cart" button
        qtyWrapper.classList.add('hidden'); // Hide quantity selector
        qtyInput.value = 1; // Reset quantity input for next add
      } else {
        // Item is still in cart with a positive quantity
        qtyInput.value = updatedItem.quantity; // Ensure input reflects actual cart quantity
        // The button and wrapper should already be in the correct state (button hidden, wrapper visible)
      }
      return cartData;
    })
    .catch(err => {
      console.error('❌ Error updating cart:', err);
      alert('❌ Error updating cart');
      // Revert UI if update failed (optional, depending on desired error handling)
    });
  }
});